import { render, staticRenderFns } from "./ShowAdvanced.vue?vue&type=template&id=6fcde9e8&scoped=true&lang=pug"
import script from "./ShowAdvanced.vue?vue&type=script&lang=js"
export * from "./ShowAdvanced.vue?vue&type=script&lang=js"
import style0 from "./ShowAdvanced.vue?vue&type=style&index=0&id=6fcde9e8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcde9e8",
  null
  
)

export default component.exports